import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslationKeyMap } from '../coaching-insight.i18n';

// TODO move to model?
export interface DateRange {
    startDate: Date;
    endDate: Date;
}

@Component({
    selector: '[cmpsSelectPeriodDateRange]',
    template: ` <div class="spdr-head">
            {{
                _i18n._9604_SELECT_THE_PERIOD__WEEK__YOU_WANT_TO_SEE | translate
            }}
        </div>
        <div class="spdr-container">
            <div
                class="spdr-row"
                *ngFor="let i of dateRanges"
            >
                <button
                    class="btn bg-transparent p-0"
                    [class.spdr-selected]="i === selection"
                    (click)="selectionChange.emit(i)"
                >
                    <span class="spdr-start-end">{{
                        i.startDate | date: 'dd-MM-yyyy'
                    }}</span>
                    <span class="spdr-to">{{
                        _i18n._9253_TO | translate
                    }}</span>
                    <span class="spdr-start-end">{{
                        i.endDate | date: 'dd-MM-yyyy'
                    }}</span>
                </button>
            </div>
        </div>`,
    host: {
        'data-e2e': 'component-select-period-date-range',
    },
})
export class SelectPeriodDateRangeComponent {
    /** @private */ _i18n = TranslationKeyMap;

    @Input() dateRanges: DateRange[];
    @Input() selection: DateRange;
    @Output() selectionChange: EventEmitter<DateRange>;

    constructor() {
        this.selectionChange = new EventEmitter();
    }
}
